module.exports = __webpack_public_path__ + "static/img/bit_logo.ba939c4a.png";